import { type LogoutPageProps } from '../../codegen/LogoutPageProps';
import { type FlowProps } from '../../FlowProps';

/**
 * Logout flow page.
 * @param {LogoutPageProps} props page parameters
 * @returns {object} component
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LogoutPage = (props: FlowProps<LogoutPageProps>) => {
    // ONEDAY: not currently used
    return <></>;
};

export default LogoutPage;
